<script>
import axios from "axios";
import moment from "moment";

export default {
  props: {
    open: {
      type: Boolean,
      required: false,
      default: false,
    },
    dispatch: {
      type: [Object],
      required: false,
    },
  },
  emits: ["close-modal", "refetch"],
  data() {
    return {
      requestDocsIsPending: false,
      checkDocsIsSuccess: true,
      downloadDocIsPending: undefined,
      unavailableFiles: [],
    };
  },
  methods: {
    async requestDocumentsCompilation() {
      this.requestDocsIsPending = true;

      try {
        const { data: checkDocsData, status } = await axios.get(
          `api/admin/documentos/${this.dispatch?.id}/descargar-compilacion/check`
        );

        if (checkDocsData?.message) {
          console.log(checkDocsData?.message);

          this.$swal({
            icon: "error",
            title: "Error",
            text: "Los documentos no se encuentran disponibles",
          });

          this.checkDocsIsSuccess = false;
          this.requestDocsIsPending = false;
          this.$emit("close-modal");
          return;
        }

        if (checkDocsData?.data) {
          this.unavailableFiles = [...checkDocsData.data.excluded_files];

          if (this.unavailableFiles.length == 0) {
            await this.downloadDocumentCompilation();
            this.$emit("close-modal");
          }

          this.checkDocsIsSuccess = true;
        }
      } catch (e) {
        console.error(e);
      }
      this.requestDocsIsPending = false;
    },
    async downloadDocumentCompilation() {
      const config = {
        responseType: "blob",
      };

      this.downloadDocIsPending = true;
      try {
        const { data } = await axios.get(
          `api/admin/documentos/${this.dispatch?.id}/descargar-compilacion`,
          config
        );

        if (data) {
          const href = URL.createObjectURL(data);

          const link = document.createElement("a");
          link.href = href;
          link.setAttribute(
            "download",
            this.dispatch?.codigo +
              "-" +
              this.moment(new Date()).format("DD-MM-YYYY")
          );
          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
          URL.revokeObjectURL(href);
        }
      } catch (e) {
        console.error(e);

        const parsedErr = await e?.response?.data?.text();
        const json = JSON.parse(parsedErr);

        if (json?.message) {
          this.$swal({
            icon: "error",
            title: "Error",
            text: json.message,
          });
        }
      }
      this.downloadDocIsPending = false;
      this.$emit("close-modal");
    },
  },
  watch: {
    open: async function (newValue) {
      if (newValue == true) {
        await this.requestDocumentsCompilation();
      }
    },
  },
};
</script>

<template>
  <div>
    <b-modal
      v-model="open"
      id="modal-export-documents"
      centered
      @hidden="() => $emit('close-modal')"
      hide-footer
      :hide-header="requestDocsIsPending"
    >
      <template #modal-title> Información </template>

      <div
        v-if="requestDocsIsPending"
        class="h-48 flex flex-row items-center justify-center"
      >
        <b-spinner class="text-primary" style="width: 3em; height: 3em" />
      </div>

      <div
        class="flex flex-col gap-4 p-2"
        v-if="!requestDocsIsPending && checkDocsIsSuccess"
      >
        <div class="flex flex-col gap-4 overflow-auto">
          <div class="flex flex-row gap-4">
            <fas size="lg" icon="info" class="mt-1" />
            <p class="font-semibold">
              Los siguientes documentos no estarán disponibles en el archivo
              final
            </p>
          </div>
        </div>

        <div
          class="flex flex-row items-center border bg-light"
          v-if="unavailableFiles?.length > 0"
        >
          <ul class="text-left list-disc px-4 py-2 my-auto w-full">
            <li v-for="(file, i) in unavailableFiles" :key="i">
              {{ file ?? "Sin-nombre" }}
            </li>
          </ul>
        </div>

        <div class="flex flex-row items-center justify-end gap-2">
          <b-spinner class="text-primary mr-auto" v-if="downloadDocIsPending" />
          <button
            type="button"
            class="btn-principal btn-large"
            @click="() => $emit('close-modal')"
          >
            Cerrar
          </button>

          <button
            v-if="checkDocsIsSuccess"
            :disabled="downloadDocIsPending"
            type="button"
            class="btn-secundario btn-large"
            @click="downloadDocumentCompilation()"
          >
            Descargar
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
